module.exports = __webpack_public_path__ + "97e5ddc0fef4ebc2c833031e2f8008a7.png";